(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cj-pdp-main"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('cj-product'))customElements.define('cj-product',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      this.variants=JSON.parse(this.querySelector('[data-variants]').textContent);
      this.select=this.querySelector('select[name="id"]');this.add=this.querySelector('[name="add"]');
      this.querySelector('.cj-pdp__options').hidden=false;this.select.hidden=true;
      this.addEventListener('click',e=>{const thumb=e.target.closest('[data-media]');if(thumb)this.showMedia(thumb.dataset.media)});
      this.addEventListener('change',e=>{if(e.target.type!=='radio')return;const values=[...this.querySelectorAll('fieldset')].map(f=>{const v=f.querySelector('input:checked')?.value;f.querySelector('[data-choice]').textContent=v||'';return v});const variant=this.variants.find(v=>v.options.every((o,i)=>o===values[i]));this.select.value=variant?String(variant.id):'';this.add.disabled=!variant?.available;this.add.textContent=variant?(variant.available?this.add.dataset.addLabel:this.add.dataset.soldLabel):this.add.dataset.unavailableLabel;if(!variant)return;this.querySelector('[data-price]').innerHTML=variant.price;const compare=this.querySelector('[data-compare]');compare.hidden=!variant.compare;compare.innerHTML=variant.compare||'';if(variant.media)this.showMedia(String(variant.media));const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url)});
      this.querySelector('form').addEventListener('submit',e=>{if(!this.select.value||this.add.disabled)e.preventDefault()});
      const initial=this.variants.find(v=>String(v.id)===this.select.value);if(initial?.media)this.showMedia(String(initial.media));
    }
    showMedia(id){this.querySelectorAll('[data-panel]').forEach(p=>{p.hidden=p.dataset.panel!==id;if(p.hidden)p.querySelectorAll('video').forEach(v=>v.pause())});this.querySelectorAll('[data-media]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.media===id)))}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clarendale-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.chReady === 'true') return;
      root.dataset.chReady = 'true';
      const slides = [...root.querySelectorAll('[data-ch-slide]')];
      const dots = [...root.querySelectorAll('[data-ch-dot]')];
      if (slides.length < 2) return;
      let active = 0;
      let timer;
      const show = (index) => {
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, position) => {
          const selected = position === active;
          slide.classList.toggle('is-active', selected);
          slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
        });
        dots.forEach((dot, position) => {
          const selected = position === active;
          dot.classList.toggle('is-active', selected);
          dot.setAttribute('aria-current', selected ? 'true' : 'false');
        });
      };
      const start = () => {
        window.clearInterval(timer);
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = window.setInterval(() => show(active + 1), 7000);
      };
      dots.forEach((dot, index) => dot.addEventListener('click', () => { show(index); start(); }));
      start();
    };
    const boot = () => document.querySelectorAll('[data-clarendale-hero]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-clarendale-hero]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clarendale-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.chReady === 'true') return;
      root.dataset.chReady = 'true';
      const hero = root.querySelector('.ch-hero');
      const slides = [...root.querySelectorAll('[data-ch-slide]')];
      const dots = [...root.querySelectorAll('[data-ch-dot]')];
      if (!hero || slides.length < 2) return;
      let active = 0;
      let timer;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const show = (next) => {
        active = (next + slides.length) % slides.length;
        slides.forEach((slide, index) => {
          const selected = index === active;
          slide.classList.toggle('is-active', selected);
          slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
        });
        dots.forEach((dot, index) => {
          const selected = index === active;
          dot.classList.toggle('is-active', selected);
          dot.setAttribute('aria-current', selected ? 'true' : 'false');
        });
      };
      const stop = () => window.clearInterval(timer);
      const play = () => {
        stop();
        if (!reducedMotion) timer = window.setInterval(() => show(active + 1), 6000);
      };
      dots.forEach((dot) => dot.addEventListener('click', () => {
        show(Number(dot.dataset.chDot));
        play();
      }));
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        hero.addEventListener('mouseenter', stop);
        hero.addEventListener('mouseleave', play);
      }
      play();
    };
    document.querySelectorAll('[data-clarendale-home]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-clarendale-home]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
